<template>
  <section
    v-if="acknowledgement"
    class="current-acknowledgement-section"
  >
    <div class="d-flex align-center">
      <div class="text-h2 section-title mr-2">
        Current Acknowledgement
      </div>
      <StatusPill
        :status-key="acknowledgementStatusKey(acknowledgement.status)"
        :label="acknowledgementStatusLabel(acknowledgement.status)"
      />
    </div>
    <div class="current-info-grid text-body-2 text-textLight">
      <span class="current-info-label text-textDark font-weight-bold">Job Profile Title</span>
      <span>{{ acknowledgement.title || '—' }}</span>
      <span class="current-info-label text-textDark font-weight-bold">Job Code</span>
      <span>{{ acknowledgement.hris_job_code || '—' }}</span>
      <span class="current-info-label text-textDark font-weight-bold">Created</span>
      <span class="current-created-cell">
        <span>{{ formatDisplayDate(acknowledgement.created_at) }}</span>
        <span
          v-if="acknowledgement.created_by?.name"
          class="text-textLight"
        >
          by {{ acknowledgement.created_by.name }}
        </span>
      </span>
      <template v-if="acknowledgement.signed_at">
        <span class="current-info-label text-textDark font-weight-bold">Finalized At</span>
        <span>{{ formatDisplayDate(acknowledgement.signed_at) }}</span>
      </template>
    </div>
    <div
      v-if="$slots.footer"
      class="current-ack-footer"
    >
      <slot name="footer" />
    </div>
  </section>
</template>

<script setup>
import StatusPill from '@/components/shared/StatusPill.vue';
import { formatDisplayDate } from '@/helpers/date';
import {
  acknowledgementStatusKey,
  acknowledgementStatusLabel,
} from '@/components/library/employeeAcknowledgements/helpers';

defineProps({
  acknowledgement: {
    type: Object,
    default: null,
  },
});

</script>

<style scoped lang="less">
.current-acknowledgement-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;

  .section-title {
    margin-bottom: 4px;
  }

  .current-ack-footer {
    display: flex;
    justify-content: flex-start;
  }

  .current-info-grid {
    display: grid;
    grid-template-columns: 120px 1fr;
    column-gap: 16px;
    row-gap: 4px;
    line-height: 1.5;
  }

  .current-info-label {
    white-space: nowrap;
  }

  .current-created-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
}
</style>
